/** Maps a document status to the Badge color variant used to render it. */
export const statusMap = {
    cancelled: 'danger',
    complete: 'success',
    sent: 'incomplete',
    partial: 'common',
    voided: 'common',
};
/**
 * Translation keys for each document status. `ec__status` arrives as a raw enum from Cortex,
 * so we map it to a localized label rather than rendering it verbatim. Keep this in sync with
 * `DOCUMENT_STATUSES` — `participant_documents.status.test.ts` fails if a status is missing.
 */
export const statusLabelMap = {
    cancelled: 'label.participant_documents.status.cancelled',
    complete: 'label.participant_documents.status.complete',
    sent: 'label.participant_documents.status.sent',
    partial: 'label.participant_documents.status.partial',
    voided: 'label.participant_documents.status.voided',
};
